import { Settings, Shield, User } from 'lucide-react';
import React from 'react';

const ControlPanelContent = ({ scenario, onComplete }) => {
  return (
    <div className="h-full bg-white p-4">
      <h2 className="text-xl font-bold mb-4">Control Panel</h2>
      <div className="grid grid-cols-3 gap-4">
        <div className="p-4 border rounded cursor-pointer hover:bg-gray-50">
          <User size={24} className="mb-2" />
          <span className="text-sm">User Accounts</span>
        </div>
        <div className="p-4 border rounded cursor-pointer hover:bg-gray-50">
          <Shield size={24} className="mb-2" />
          <span className="text-sm">Security and Maintenance</span>
        </div>
        <div className="p-4 border rounded cursor-pointer hover:bg-gray-50">
          <Settings size={24} className="mb-2" />
          <span className="text-sm">System</span>
        </div>
      </div>
    </div>
  );
};

export default ControlPanelContent;

